import { getIsQuizInProgress } from '@/modules/corporate/modules/quiz/utils';
import { QuizDetailsPerformanceFragment } from '@/modules/corporate/modules/quiz/views/QuizDetails/graphql/fragments/generated/QuizDetailsPerformance';
import getQuizModifiedAttempts from '@/modules/corporate/modules/quiz/views/QuizDetails/utils/getQuizModifiedAttempts';

/**
 * Whether the collapsed inline card should offer the "History" entry point.
 *
 * Unlike the standalone quiz details page — which splits into "Attempt History"
 * (retakeAllowedCount > 1) and "View Results" (single attempt) — the inline card
 * has one button, so it opens the list for any finished attempt, even a single one.
 */
export const getShowAttemptHistory = (quizPerformance?: QuizDetailsPerformanceFragment) =>
  !getIsQuizInProgress(quizPerformance) && getQuizModifiedAttempts(quizPerformance).length >= 1;
